import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

export default function LoadingScreen() {
  return (
    <Box
      sx={{
        marginTop: '10%',
        flex: 1,
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress size={80} />
    </Box>
  )
}
